import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { fieldsToOmit } from 'providers/tanstack-query/utils'

import type { Schema } from 'features/globalSetup/pages/GeneralPage/forms/WorkspaceForm/schema'
import type { UpdateWorkspaceForGlobalSetupGeneralMutationVariables } from 'gql/graphql'
import type { Ability } from 'providers/casl'

type Variables = UpdateWorkspaceForGlobalSetupGeneralMutationVariables['input']

export const toDTO = (from: Schema, ability: Ability) =>
  mapDTO<Schema, Variables>({ from }).transform((data: Schema) => {
    const { id, name, priceGeniusAlwaysOn } = data

    const constantFields: Pick<Variables, 'id' | 'name'> = {
      id,
      name,
    }

    const variableFields: Pick<Variables, 'priceGeniusAlwaysOn'> = {
      priceGeniusAlwaysOn,
    }

    return {
      ...constantFields,
      ...omit(
        variableFields,
        fieldsToOmit<Variables>({
          priceGeniusAlwaysOn: ability.cannot('update', 'GlobalSetupField-priceGenius'),
        }),
      ),
    }
  })
